/**
* Before and After Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Before and After Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'before-and-after-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      if ( $( '.before-and-after-slider' ).length ) {
        $( '.before-and-after-slider' ).each( function( index, element ) {
          console.log( $( element ) );
          $( element ).find( '.before-after-slider-outer' ).slick( {
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: $( element ).find( '.before-and-after-slider__prev' ),
            nextArrow: $( element ).find( '.before-and-after-slider__next' ),
          } );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'before-and-after-slider', COMPONENT );
} )( app );
